const hashNavigation = require("swiper/src/components/hash-navigation/hash-navigation");
module.exports = function () {

  const DESKTOP_BREAKPOINT = 1025;

  function CleanStyles(element) {
    element.removeAttribute('style');
  }

  function ToggleMenu() {
    if (window.innerWidth >= DESKTOP_BREAKPOINT) {
      const navButton = this;
      const navButtonCoordinates = navButton.getBoundingClientRect();
      const subNav = navButton.querySelector('ul[data-columns]');

      if (subNav) {
        const subNavCoordinates = subNav.getBoundingClientRect();
        const windowWidth = window.innerWidth;
        const subNavWidth = subNavCoordinates.width;
        const containerMaxWidth = 1440;


        if (subNavWidth >= containerMaxWidth && windowWidth > containerMaxWidth) {
          if (subNav.dataset.columns === '5') {
            const offset = (windowWidth - containerMaxWidth) / 2;
            const total = offset - navButtonCoordinates.left;
            CleanStyles(subNav);

            subNav.style.transform = 'translateX(' + total + 'px)';
            subNav.style.left = '0';
          }
        } else {

          if (subNav.dataset.columns === '5') {
            CleanStyles(subNav);

            subNav.style.transform = 'translateX(-' + navButtonCoordinates.left + 'px)';
            subNav.style.left = '0';
          }

          if (subNav.dataset.columns === '3') {
            if (subNavCoordinates.left < 0) {
              CleanStyles(subNav);
              
              subNav.style.transform = 'translateX(-' + (navButtonCoordinates.left) + 'px)';
              subNav.style.left = '0';
            }
          }
        }
      }
    }
  }

  $('header [data-type="Navigation Section"]').on('click', ToggleMenu);
  $('header [data-type="Navigation Section"]').on('mouseover', ToggleMenu);

  $('header').on('click', '[data-type="Open Search"]', function () {
    $(this).closest('header').find(".A1-header__search-btn").toggleClass('close-btn');
    $(this).closest('header').find(".search-dropdown").toggleClass('active');
    $(this).closest('header').find("nav").removeClass("active");
  });

  $('header').on('click', '.search-bar__close-cta', function () {
    $(this).closest('header').find(".search-dropdown").toggleClass('active');
  });

  $("header").on("click", ".A1-header__search-btn", function (e) {
    e.preventDefault();
    $(this).closest("header").removeClass("has-menu-active");
    $("body").removeClass("no-scroll");
  });

  $("header").on("click", ".mobile-navigation-menu", function (e) {
    e.preventDefault();
    $(this).closest("nav").toggleClass("active");
    $(this).closest('header').find(".search-dropdown").removeClass('active');
    $(this).closest('header').toggleClass('has-menu-active');
    if ($(this).closest("nav").hasClass("active")) {
      $('.header-overlay').addClass('active');
      $('body').addClass('no-scroll');
    } else {
      $('.header-overlay').removeClass('active');
      $('body').removeClass('no-scroll');
    }
  });

//Nav Section
  $("header").on("click", "nav > ul > li > span", function () {
    if (window.innerWidth > 1024) {
      return;
    }
    $(this).closest("li").toggleClass("active");
  });

//Nav Group
  $("header").on("click", "nav > ul > li > ul > li > ul > li > span", function () {
    $(this).closest("li").toggleClass("active");
    $(this).closest("li").find('ul').toggleClass("active");
  });
  $("header").on("click", "nav > ul > li > ul > li > ul > li > a.disableMobileLink", function (e) {
    if ($(window).width() <= 1024) {
      e.preventDefault();
      $(this).closest("li").toggleClass("active");
      $(this).closest("li").find('ul').toggleClass("active");
    }
  });
};
